import { findIndex } from "lodash";
import InlineSelect from "PFComponents/select/inline_select";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./template_tab.module.scss";

const TemplateTab = ({ onTemplateChange, allTemplates, template }) => {
  const { t } = useTranslation();
  const [exportFormat, setExportFormat] = useState(template?.export_format || "pptx");

  const exportOptions = [
    { id: "pdf", item: "pdf", displayElement: "pdf" },
    { id: "pptx", item: "pptx", displayElement: "pptx" },
    { id: "docx", item: "docx", displayElement: "docx" },
    { id: "csv", item: "csv", displayElement: "csv" }
  ];

  const templateOptions = useMemo(
    () =>
      allTemplates
        .filter((template) => template.export_format === exportFormat)
        .map((template) => ({ id: template.key, item: template, displayElement: template.display_as })),
    [allTemplates, exportFormat]
  );

  // Select default template
  useEffect(() => {
    if (!template) {
      const defaultTemplate =
        templateOptions.find(({ item }) => item.default)?.item || templateOptions[0]?.item;
      defaultTemplate && onTemplateChange(defaultTemplate);
    }
  }, [templateOptions, template]);

  const selectedExportTypeIndex = findIndex(exportOptions, { id: exportFormat });
  const selectedTemplateIndex = findIndex(templateOptions, { id: template?.key });

  return (
    <div className={css.container}>
      <InlineSelect
        rootClassName={css.inlineSelect}
        label={t("export.templates.selectExportType")}
        value={exportFormat && exportOptions.find(({ id }) => id === exportFormat)?.displayElement}
        onChange={(val) => {
          setExportFormat(val);
          onTemplateChange(null);
        }}
        selectedIndex={selectedExportTypeIndex}
        options={exportOptions}
      />

      {exportFormat && (
        <InlineSelect
          rootClassName={css.inlineSelect}
          label={t("export.templates.selectTemplate")}
          value={template && templateOptions.find(({ id }) => id === template.key)?.displayElement}
          onChange={(val) => onTemplateChange(val)}
          selectedIndex={selectedTemplateIndex}
          options={templateOptions}
        />
      )}
    </div>
  );
};

const templateProps = {
  key: PropTypes.string.isRequired,
  export_format: PropTypes.string,
  display_as: PropTypes.string.isRequired
};

TemplateTab.propTypes = {
  onTemplateChange: PropTypes.func.isRequired,
  template: PropTypes.shape(templateProps),
  allTemplates: PropTypes.arrayOf(PropTypes.shape(templateProps))
};

export default TemplateTab;
